import { render, staticRenderFns } from "./page-backlog.vue?vue&type=template&id=46cf8672&scoped=true"
import script from "./page-backlog.vue?vue&type=script&lang=js"
export * from "./page-backlog.vue?vue&type=script&lang=js"
import style0 from "./page-backlog.vue?vue&type=style&index=0&id=46cf8672&prod&scoped=true&lang=css"
import style1 from "./page-backlog.vue?vue&type=style&index=1&id=46cf8672&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cf8672",
  null
  
)

export default component.exports